import { schemas, ZInfer } from '@showrunner/scrapi'

export type TrackedChange = ZInfer<typeof schemas.TrackedChange>
export type TrackedChangeActor = ZInfer<typeof schemas.TrackedChangeActor>
export type TrackedChangeReply = ZInfer<typeof schemas.TrackedChangeReply>

export type TrackedChangeStatus = ZInfer<typeof schemas.TrackedChangeStatus>
export const TrackedChangeStatusOptions = schemas.TrackedChangeStatus.options

export type TrackedChangeType = ZInfer<typeof schemas.TrackedChangeType>
export const TrackedChangeTypeOptions = schemas.TrackedChangeType.options
